import { SUPPORT_CONTACT } from "../../const/AppConst";
import MgpButton from "../../elements/MgpButton/MgpButton";

interface SubscriptionEndComponentProps {
 
}

export default function SubscriptionEndCreateAccountComponent({} : SubscriptionEndComponentProps) {

    const handleClick = () => {
        window.location.href = process.env.REACT_APP_ADHERENT_BASE_URL + "/creation-compte";
    }

    return (             
        <form style={{width: '100%', textAlign: "justify"}}>
        
        <p className="card-title bleu mb-md">Votre identification est finalisée</p>    
    
        <p className='text m-y-sm'>Votre numéro d'adhérent a été envoyé par mail, il est nécessaire à la création de votre espace adhérent.</p>
        <p className='text m-y-sm'>Vous pouvez le créer dès à présent afin de pouvoir :</p>
        <ul className='list-bullet-noir'>
            <li> Modifier ou compléter vos données personnelles.</li>
            <li>Renforcer votre couverture en souscrivant aux options.</li>
            <li>Ajouter vos ayants droit.</li>
        </ul>

            

        <div className='form-row jc-right mt-xl'>
            <MgpButton
                id="submitButton"
                type="button"
                text= {"Créer mon compte"}
                icon='chevron-right'
                iconPosition="right"
                onClick={handleClick}
            ></MgpButton>  
        </div>

        <a className="bleu link mt-lg hide-in-desktop" href={`tel:${SUPPORT_CONTACT}`}>Besoin d'aide ?</a>
            
        </form>
    )
}
